/**
 * The distance the popover box should have from its content, in pixels.
 * @type {Number}
 */
export const BOX_DISTANCE = 8;

/**
 * The configuration object passed to the component's MutationObserver.
 * @type {MutationObserverInit}
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserverInit
 */
export const MUTATION_OBSERVER_CONFIG = {
    attributes: ['class'],
    childList: true,
    subtree: true,
    characterData: true
};
